exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "instance-links .collapsible-section:first-child {\n  border-top-width: 0 !important;\n}\n", ""]);

